import { getVanDerValkSelectedSuitabilityRow } from 'projectSections/designPanels/PanelModuleGrid/getMountingFieldOverrides'
import type { StudioSystemType } from 'types/studio/items'
import {
  applySelectedVanDerValkSuitability,
  applyVanDerValkPanelLayoutFromRow,
} from './applyVanDerValkSuitabilityResultToSystem'
import { resolveRowForPanelLayoutApply, serializeSuitabilityFieldValue } from './suitabilityOptions'

export { applyVanDerValkPanelLayoutFromRow } from './applyVanDerValkSuitabilityResultToSystem'

/** Read `integration_json.vanDerValk.selectedSuitability` and apply panel layout when mounting is Van der Valk. */
export function syncVanDerValkPanelLayoutFromSelectedSuitability(
  system: StudioSystemType | null | undefined
): void {
  if (!system || system.mounting !== 'vanDerValk') {
    return
  }
  const row = getVanDerValkSelectedSuitabilityRow(system)
  if (!row) {
    return
  }
  const alignedRow = resolveRowForPanelLayoutApply(system, row)
  const needsPersist =
    serializeSuitabilityFieldValue(row.moduleOrientation) !==
    serializeSuitabilityFieldValue(alignedRow.moduleOrientation)
  if (needsPersist) {
    applySelectedVanDerValkSuitability(system, row)
    return
  }
  applyVanDerValkPanelLayoutFromRow(system, row)
}

export function syncVanDerValkPanelLayoutForAllSystems(systems: StudioSystemType[]): void {
  for (const system of systems) {
    syncVanDerValkPanelLayoutFromSelectedSuitability(system)
  }
}

export function syncVanDerValkPanelLayoutForEditor(
  editor: { getSystems?: () => StudioSystemType[] } | null | undefined
): void {
  const systems = editor?.getSystems?.()
  if (!systems?.length) {
    return
  }
  syncVanDerValkPanelLayoutForAllSystems(systems)
}
